<template>
  <div>
    <!--
      Extrato de taxas da plataforma: uma linha por venda com o breakdown
      bruto | taxa (% e R$) | líquido, direto do snapshot fin.applied_fees.
      É a resposta de "quanto a Hubee reteve desta venda e por quê" — o grid de
      Split mostra só o resultado por recebedor, sem nomear a taxa.
    -->
    <Grid
      :service="service"
      route_name="financial_fees"
      route_grid_path="/grid"
      order_column="created_at"
      direction="desc"
      hide_actions="true"
      :show-export="true"
      :export-types="['csv', 'xls']"
      export-filename="hubee_taxas_plataforma"
      :fetch-on-mounted="false"
      hide_searchbar="true"
      ref="grid"
    >
      <template v-slot:filterZone>
        <FinancialPeriodFilter v-model="filters" @change="handleFilterChange" />
      </template>

      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="order_id" sort-key="order_id">Pedido</vs-th>
        <vs-th key="gross_value">Valor da venda</vs-th>
        <vs-th key="fee_percent">Taxa (%)</vs-th>
        <vs-th key="fee_value">Taxa (R$)</vs-th>
        <vs-th key="net_value">Valor líquido</vs-th>
        <vs-th key="source">Origem</vs-th>
        <vs-th key="created_at" sort-key="created_at">Data</vs-th>
      </template>

      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td width="8%" key="order_id">
            <div>{{ tr.order_id }}</div>
          </vs-td>
          <vs-td width="15%" key="gross_value">
            <span class="hb-money">{{ formatCurrency(tr.gross_value) }}</span>
          </vs-td>
          <vs-td width="10%" key="fee_percent">
            <div>{{ formatPercent(tr.fee_percent) }}</div>
          </vs-td>
          <vs-td width="13%" key="fee_value">
            <span class="hb-money">{{ formatCurrency(tr.fee_value) }}</span>
          </vs-td>
          <vs-td width="15%" key="net_value">
            <span class="font-semibold hb-money">{{ formatCurrency(tr.net_value) }}</span>
          </vs-td>
          <vs-td width="14%" key="source">
            <vs-chip :color="tr.source === 'PLAN' ? 'primary' : 'warning'" class="text-base">
              {{ getSourceLabel(tr.source) }}
            </vs-chip>
          </vs-td>
          <vs-td width="20%" key="created_at">
            <div>{{ $utils.format.date(tr.created_at) }}</div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import FinancialPeriodFilter from '@/components/filters/FinancialPeriodFilter.vue'
import FeeStatementService from '@/services/api/FeeStatementService'
import { currencyFormatter } from '@/util/Util'

export default {
  components: {
    Grid,
    FinancialPeriodFilter
  },
  data() {
    return {
      service: null,
      filters: {
        institution_id: null,
        start_date: null,
        end_date: null
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return currencyFormatter(value)
    },
    formatPercent(value) {
      if (value === null || value === undefined) return '—'
      return `${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
    },
    getSourceLabel(source) {
      return source === 'PLAN' ? 'Plano de cobrança' : 'Contrato (legado)'
    },
    handleFilterChange(filters) {
      this.filters = filters
      this.updateFilters()
    },
    updateFilters() {
      const customFilters = {}

      if (this.filters.institution_id) {
        customFilters.institution_id = this.filters.institution_id
      }

      if (this.filters.start_date) {
        customFilters.start_date = this.filters.start_date
      }

      if (this.filters.end_date) {
        customFilters.end_date = this.filters.end_date
      }

      this.$refs.grid.custom_filters = []

      if (Object.keys(customFilters).length > 0) {
        this.$refs.grid.fillCustomFilters(
          Object.keys(customFilters).map(key => ({
            key,
            value: customFilters[key]
          }))
        )
      }

      this.$refs.grid.fetchGridData(true)
    }
  },
  beforeMount() {
    this.service = FeeStatementService.build(this.$vs)
  }
}
</script>
